import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import AdminDashboard from "@/pages/AdminDashboard";
import { OrderCaptureProvider } from "@/components/OrderCapture";
import { CartProvider } from "@/context/CartContext";
import CartDrawer from "@/components/CartDrawer";
import ItemDetailsModal from "@/components/ItemDetailsModal";
import "@/App.css";

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground antialiased">
      <BrowserRouter>
        <CartProvider>
          <OrderCaptureProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
            <CartDrawer />
            <ItemDetailsModal />
          </OrderCaptureProvider>
        </CartProvider>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            color: "#2C2825",
            border: "1px solid #E8E2D6",
            fontFamily: "DM Sans, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
